module.exports = "/_next/static/images/5176accd456ffe3041f6e3b6a30022f0-man-looking-at-phone@xs-2x.jpg.webp";